import React, { useState, useEffect } from 'react';
import {
  Autocomplete,
  Box,
  Button,
  Chip,
  InputAdornment,
  Grid,
  Tooltip,
  Dialog,
  TextField,
  Container,
  Paper,
  Typography,
  IconButton,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import DateObject from 'react-date-object';
import {
  CANCEL_BUTTON_TEXT,
  SHOW_NOTIFICATION,
  SUBMIT_BUTTON_TEXT,
} from '../../../../constants';
import { useDispatch } from 'react-redux';
import { getUsers } from '../../../../services/UserService';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { ERROR_KEY } from '../../../../constants';
import { Calendar } from 'react-multi-date-picker';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import {
  applyExternalQuota,
  applyClientOfficeQuota,
  applyWorkTravelQuota,
} from '../../../Services/EmployeePrivilegesService';

const ApplyExternalQuota = (props) => {
  const {
    toggleOpen,
    refresh,
    setRefresh,
    setLoader,
    hoursType = 'external',
  } = props;
  const quotaLabel =
    hoursType === 'clientOffice'
      ? 'Client Office Hours'
      : hoursType === 'workTravel'
        ? 'Work Travel Hours'
        : 'External Hours';
  const [search, setSearch] = useState(new Map([[0, false]]));
  const [loadingApiCall, setLoadingApiCall] = useState(false);
  const [externalQuotaPayload, setExternalQuotaPayload] = useState([]);
  const dispatch = useDispatch();
  const [openPicker, setOpenPicker] = useState(new Map([[0, false]]));
  const [toSubjects, setToSubjects] = useState([]);

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  useEffect(() => {
    const newExternalPayloadObject = {
      employeeId: [],
      monthRange: [],
      rangeOption: '',
      externalQuotaTime: '',
      nameError: false,
      rangeTypeError: false,
      rangeError: false,
      quotaError: false,
      quotaErrorMsg: '',
    };
    setExternalQuotaPayload([newExternalPayloadObject]);
  }, []);

  const checkOptions = (str, index) => {
    const updatedSearch = new Map(search);
    if (str.length > 1) {
      updatedSearch.set(index, true);
    } else {
      updatedSearch.set(index, false);
    }
    setSearch(updatedSearch);
  };

  const handleClickAway = (index) => {
    const updatedSearch = new Map(search);
    updatedSearch.set(index, false);
    setSearch(updatedSearch);
  };

  const handleDeleteEmployee = (employee, index) => {
    const updatedList = externalQuotaPayload[index].employeeId.filter(
      (emp) => emp.employeeId !== employee.employeeId,
    );
    const updatedExternalPayload = [...externalQuotaPayload];
    updatedExternalPayload[index].employeeId = updatedList;
    setExternalQuotaPayload(updatedExternalPayload);
  };

  const handleEmployeeListChange = (val, index) => {
    const updatedExternalPayload = [...externalQuotaPayload];
    updatedExternalPayload[index].employeeId = val;
    updatedExternalPayload[index].nameError = false;
    setExternalQuotaPayload(updatedExternalPayload);

    const updatedSearch = new Map(search);
    updatedSearch.set(index, false);
    setSearch(updatedSearch);
  };

  const addFeild = () => {
    setSearch(new Map(search.set(externalQuotaPayload.length, false)));
    const newExternalPayloadObject = {
      employeeId: [],
      monthRange: [],
      rangeOption: '',
      externalQuotaTime: '',
      nameError: false,
      rangeTypeError: false,
      rangeError: false,
      quotaError: false,
      quotaErrorMsg: '',
    };
    setExternalQuotaPayload([
      ...externalQuotaPayload,
      newExternalPayloadObject,
    ]);
  };

  const handleRemove = (index) => {
    const updatedExternalPayload = [...externalQuotaPayload];
    updatedExternalPayload.splice(index, 1);
    setExternalQuotaPayload(updatedExternalPayload);
  };

  const handleRangeOptionChange = (event, index) => {
    // when we are changing the option for type of (monthly, quaterly, custom)
    const updatedExternalPayload = [...externalQuotaPayload];
    updatedExternalPayload[index].monthRange = []; // resetting the month reange since we changed the range option
    updatedExternalPayload[index].rangeOption = event.target.value; //then setting new range type
    updatedExternalPayload[index].rangeTypeError = false;
    setExternalQuotaPayload(updatedExternalPayload);
  };

  const handleMonthRangeChange = (props, index) => {
    const updatedExternalPayload = [...externalQuotaPayload];
    if (externalQuotaPayload[index].rangeOption === 'Quarterly') {
      if (props.value.length === 1) {
        updatedExternalPayload[index].monthRange = [
          props.value[0],
          new DateObject(props.value[0]).add(2, 'month'), // for quaterly we are making list that gives range with selected one as list[0] (jan), and the list[1] is 3rd to that selected list[0] (march)
        ];
        updatedExternalPayload[index].rangeError = false;
        setExternalQuotaPayload(updatedExternalPayload);
        const picker = new Map(openPicker).set(index, false); // calendar closes after selecting a month
        setOpenPicker(picker);
      }
    }
    if (externalQuotaPayload[index].rangeOption === 'Monthly') {
      updatedExternalPayload[index].monthRange = [
        //for monthly only one item in list
        props.value[props.value.length - 1],
      ];
      updatedExternalPayload[index].rangeError = false;
      setExternalQuotaPayload(updatedExternalPayload);
      const picker = new Map(openPicker).set(index, false); // after selecting month calendar closes
      setOpenPicker(picker);
    }
    if (externalQuotaPayload[index].rangeOption === 'Custom') {
      updatedExternalPayload[index].monthRange = props.value;
      updatedExternalPayload[index].rangeError = false;
      setExternalQuotaPayload(updatedExternalPayload);
      if (props.value.length === 2) {
        const picker = new Map(openPicker).set(index, false); // calendar closes when select two months
        setOpenPicker(picker);
      }
    }
  };

  const toggleClosePicker = (index) => {
    const picker = new Map(openPicker).set(index, false);
    setOpenPicker(picker);
  };

  const handleRefershClick = (event, index) => {
    event.stopPropagation();
    const updatedExternalPayload = [...externalQuotaPayload];
    updatedExternalPayload[index].monthRange = [];
    setExternalQuotaPayload(updatedExternalPayload);
  };

  const CreatePayloadforApiCall = () => {
    let payload = [];
    externalQuotaPayload.forEach((obj) => {
      let newPayloadObject = {
        employeeIds: [],
        monthRange: [],
        externalHoursQuota: 18,
      };
      newPayloadObject.employeeIds = obj.employeeId.map(
        (emp) => emp.employeeId,
      );

      if (obj.monthRange.length === 1) {
        newPayloadObject.monthRange = [
          obj.monthRange[0].year,
          obj.monthRange[0].month.number,
          obj.monthRange[0].year,
          obj.monthRange[0].month.number,
        ];
      } else if (obj.monthRange.length === 2) {
        newPayloadObject.monthRange = [
          obj.monthRange[0].year,
          obj.monthRange[0].month.number,
          obj.monthRange[1].year,
          obj.monthRange[1].month.number,
        ];
      }
      newPayloadObject.externalHoursQuota = obj.externalQuotaTime;
      payload.push(newPayloadObject);
    });
    return payload;
  };

  const dataValidation = () => {
    const updatedExternalQuotaPaload = externalQuotaPayload.map((payload) => {
      const updatedname = payload.employeeId.length !== 0;
      const updatedRangeOption = payload.rangeOption.trim() !== '';
      const updatedexternalQuota =
        /^[0-9]+$/.test(payload.externalQuotaTime) &&
        payload.externalQuotaTime.trim() !== '';
      const updatedMonthRange = payload.monthRange.length !== 0;
      return {
        ...payload,
        nameError: !updatedname,
        rangeTypeError: !updatedRangeOption,
        rangeError: !updatedMonthRange,
        quotaError: !updatedexternalQuota,
        quotaErrorMsg: !updatedexternalQuota
          ? `*Enter valid ${quotaLabel} time`
          : '',
      };
    });

    setExternalQuotaPayload(updatedExternalQuotaPaload);
    const hasError = updatedExternalQuotaPaload.some((payload) => {
      return (
        payload.nameError ||
        payload.rangeError ||
        payload.rangeTypeError ||
        payload.quotaError
      );
    });
    if (hasError) return false;
    return true;
  };

  const handleSubmit = async () => {
    if (dataValidation()) {
      const payload = CreatePayloadforApiCall();
      setLoadingApiCall(true);
      setLoader(true);
      const response =
        hoursType === 'clientOffice'
          ? await applyClientOfficeQuota(payload)
          : hoursType === 'workTravel'
            ? await applyWorkTravelQuota(payload)
            : await applyExternalQuota(payload);
      if (response.isError === false) {
        setLoadingApiCall(false);
        toggleOpen();
        setRefresh(!refresh);
      } else {
        setLoadingApiCall(false);
      }
      if (response.status !== 200) {
        dipatchNotification(response.type, response.message);
      }
    }
  };

  const handleExternalQuotaChange = (e, index) => {
    const updatedExternalPayload = [...externalQuotaPayload];
    updatedExternalPayload[index].externalQuotaTime = e.target.value;
    updatedExternalPayload[index].quotaError = false;
    updatedExternalPayload[index].quotaErrorMsg = '';
    setExternalQuotaPayload(updatedExternalPayload);
  };

  const loadData = async () => {
    const subjects = await getUsers('');
    if (subjects.status !== 200) {
      dipatchNotification(subjects.type, subjects.message);
    }
    if (subjects.isError === false) {
      setToSubjects(() => subjects.data.content);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <Container disableGutters>
      <Paper component={Box} elevation={0} p={5} pt={0}>
        <Grid container>
          <Grid
            container
            className="space-between-container"
            pt={4}
            sx={{
              backgroundColor: 'white',
              position: 'sticky',
              top: 0,
              zIndex: '2',
            }}
          >
            <Grid item>
              <IconButton sx={{ mt: '0px', ml: '-8px' }} onClick={toggleOpen}>
                <KeyboardBackspaceIcon />
              </IconButton>
            </Grid>
            <Grid item>
              <IconButton onClick={addFeild}>
                <Typography mr={1}>Add Employee</Typography>
                <AddCircleIcon color="success" />
              </IconButton>
            </Grid>
          </Grid>
          {externalQuotaPayload.map((payload, index) => (
            <Grid container sx={{ mt: '15px', mb: '20px' }} key={index}>
              <Grid item xs={12} sx={{ mb: '15px' }}>
                <Autocomplete
                  forcePopupIcon={false}
                  multiple
                  disableClearable
                  id={index.toString()}
                  open={search.get(index)}
                  isOptionEqualToValue={(option, value) =>
                    option.employeeId === value.employeeId
                  }
                  options={toSubjects.map((option) => {
                    return {
                      employeeName: option.firstName + ' ' + option.lastName + ' (' + option.employeeCode + ')',
                      employeeId: option.id,
                    };
                  })}
                  getOptionLabel={(option) => option.employeeName}
                  renderOption={(props, option) => {
                    return (
                      <li {...props} key={option.employeeId}>
                        {option.employeeName}
                      </li>
                    );
                  }}
                  onInputChange={(e) => checkOptions(e.target.value, index)}
                  value={payload.employeeId}
                  onChange={(e, val) => handleEmployeeListChange(val, index)}
                  filterSelectedOptions
                  renderTags={(tagValue, getTagProps) =>
                    tagValue.map((option, id) => (
                      <Chip
                        key={id}
                        label={option.employeeName}
                        onDelete={() => handleDeleteEmployee(option, index)}
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={payload.nameError}
                      label="Employee Name / ID"
                      placeholder="Employee Name / ID"
                    />
                  )}
                  sx={{ mt: 2 }}
                />
              </Grid>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={4}>
                    <FormControl size="small" fullWidth>
                      <InputLabel id="month-range-label">Range Type</InputLabel>

                      <Select
                        labelId="month-range-label"
                        label="Range Type"
                        error={payload.rangeTypeError}
                        value={payload.rangeOption}
                        onChange={(event) =>
                          handleRangeOptionChange(event, index)
                        }
                      >
                        <MenuItem value="Monthly">Monthly</MenuItem>
                        <MenuItem value="Quarterly">Quarterly</MenuItem>
                        <MenuItem value="Custom">Custom</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={4} sx={{ ml: 2 }}>
                    <TextField
                      name="name"
                      size="small"
                      value={payload.externalQuotaTime}
                      onChange={(e) => handleExternalQuotaChange(e, index)}
                      id={index.toString()}
                      label={`Allot ${quotaLabel} Quota`}
                      error={payload.quotaError}
                      helperText={payload.quotaErrorMsg}
                    />
                  </Grid>
                  {externalQuotaPayload.length === 1 ? null : ( //if we added employee i.e more than 1 then there will be handleclose to remove
                    <Grid item xs={2} sx={{ ml: 4 }}>
                      <Tooltip title="Remove" placement="right">
                        <IconButton onClick={() => handleRemove(index)}>
                          <CloseIcon color="error" />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                  )}
                </Grid>
              </Grid>
              <Grid item xs={12} sx={{ mt: 2 }}>
                <TextField
                  error={payload.rangeError}
                  //   helperText={error[index].monthError}
                  size="small"
                  value={payload.monthRange.join('-')}
                  disabled={payload.rangeOption === ''}
                  id={index.toString()}
                  onClick={() => {
                    const picker = new Map(openPicker).set(index, true);
                    setOpenPicker(picker);
                  }}
                  label="Month Range"
                  placeholder="Select Month Range"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Tooltip title="Referesh">
                          <IconButton
                            onClick={(e) => handleRefershClick(e, index)}
                          >
                            <RestartAltIcon />
                          </IconButton>
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                  inputProps={{
                    autoComplete: 'off',
                  }}
                />
                <Dialog
                  open={openPicker.get(index)}
                  onClose={() => toggleClosePicker(index)}
                  PaperProps={{
                    style: {
                      height: '350px',
                    },
                  }}
                >
                  <Calendar
                    placeholder="  Select Month Range"
                    onlyMonthPicker
                    id={index}
                    range={payload.rangeOption === 'Monthly' ? false : true}
                    value={payload.monthRange}
                    style={{
                      width: '100%',
                      boxSizing: 'border-box',
                      height: '38px',
                    }}
                    containerStyle={{
                      width: '100%',
                    }}
                    onPropsChange={(props) => {
                      handleMonthRangeChange(props, index);
                    }}
                  />
                </Dialog>
              </Grid>
            </Grid>
          ))}
          <Grid
            container
            className="space-between-container"
            sx={{ mt: '25px' }}
          >
            <Grid item>
              <Button onClick={toggleOpen} variant="outlined" color={ERROR_KEY}>
                {CANCEL_BUTTON_TEXT}
              </Button>
            </Grid>
            <Grid item>
              <LoadingButton
                onClick={handleSubmit}
                loading={loadingApiCall}
                variant="contained"
              >
                {loadingApiCall ? 'loading...' : SUBMIT_BUTTON_TEXT}
              </LoadingButton>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

export default ApplyExternalQuota;
